module.exports = __webpack_public_path__ + "static/img/sbshtg.0babf9a3.png";